import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import {
    TextField,
    Card,
    Breadcrumbs,
    Link,
    Typography,
    CardContent,
    Container,
    Grid,
    Backdrop,
    CircularProgress,
    Button,
    Snackbar,
    ThemeProvider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import trLocale from 'date-fns/locale/tr';
import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme } from '@material-ui/core/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { useHistory } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    getTasksRequest
} from '../../store/actions';
import { sc } from 'src/utils/Common';
import SearchBar from 'material-ui-search-bar';
import moment from 'moment';
import { workOrderCargoActions, workOrderCargoThunks } from '../../store/slices/workOrderCargoSlice'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import GetAppIcon from '@material-ui/icons/GetApp';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import * as XLSX from 'xlsx';
import ExcelExport from 'src/components/ExcelExport';

const localeMap = {
    tr: trLocale
};

const locale = localStorage.getItem('i18nextLng');

const siyah = '#424242';


const materialTheme = createMuiTheme({
    palette: {
        primary: {
            contrastText: '#FFFFFF',
            dark: siyah,
            main: siyah,
            light: siyah
        }
    }
});


const useStyles = makeStyles(theme => ({
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    cardscontent: {
        minHeight: 300
    },
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    tableRow: {
        '&$hover:hover': {
            backgroundColor: '#E4DCCF'
        }
    },
    tableCell: {
        '$hover:hover &': {
            color: 'black'
        }
    },
    hover: {},
    searchB: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIconB: {
        marginRight: theme.spacing(0),
        color: theme.palette.icon
    },
    searchInputB: {
        flexGrow: 1
    },
    searchButtonB: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
}));

function CargoReport() {
    const classes = useStyles();
    const { t } = useTranslation('overview');
    const SessionUser = getUser();
    const history = useHistory();
    const dispatch = useDispatch();
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [AlertType, setAlertType] = React.useState();
    const [ResponseDsc, setResponseDsc] = useState('');
    const [colDefs, setColDefs] = useState()
    const [ErrorMessage, setErrorMessage] = useState(null)

    const [selectedDispatchDate, setDelectedDispatchDate] = useState(moment()
        .startOf('day')
        .add(-7, 'days')
        .add(12, 'hours'))

    // const [searched, setSearched] = useState('')

    const initialCargoReportData = useSelector((state) => state.workOrderCargo.initialCargoReportData)
    const cargoReportData = useSelector((state) => state.workOrderCargo.cargoReportData)
    const cargoReportSearched = useSelector((state) => state.workOrderCargo.cargoReportSearched)

    const EXTENSIONS = ['xlsx', 'xls', 'csv']

    const GetWorkOrderCargoReport = () => {
        // setLoading(true);
        dispatch(workOrderCargoThunks.GetWorkOrderCargoReport(({ dispatchDate: moment(selectedDispatchDate).format('YYYY-MM-DD') })))
            .then((response) => {
                dispatch(workOrderCargoActions.setCargoReportData(response?.payload?.ResponseObject))
            })
            .catch(error => {
            });
    }

    const requestSearch = (searchedVal) => {
        dispatch(workOrderCargoActions.setCargoReportSearched(searchedVal))
        const filteredRows = initialCargoReportData?.filter((item) => sc(
            item.CargoCompanyId + item.CargoCompanyName + item.CargoNo + moment(item.CreateDate).format('DD-MM-YYYY')
            + moment(item.DispatchDate).format('DD-MM-YYYY') + item.Id + moment(item.UpdateDate).format('DD-MM-YYYY') + item.WorkOrderId,
            searchedVal
        ));
        dispatch(workOrderCargoActions.setCargoReportData(filteredRows));
    };

    const cancelSearch = () => {
        dispatch(workOrderCargoActions.setCargoReportSearched(cargoReportSearched))
        requestSearch(cargoReportSearched);
    };

    const getExention = (file) => {
        const parts = file.name.split('.')
        const extension = parts[parts.length - 1]
        return EXTENSIONS.includes(extension) // return boolean
    }

    const importExcel = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        if (file) {
            if (getExention(file)) {
                reader.readAsBinaryString(file);
            }
            reader.onload = (event) => {
                //parse data
                const bstr = event.target.result;
                const workBook = XLSX.read(bstr, { type: "binary" });
                //get first sheet
                const workSheetName = workBook.SheetNames[0];
                const workSheet = workBook.Sheets[workSheetName];
                //convert to array
                const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 });
                // Create excel data array
                var excelData = [];

                for (var i = 1; i < fileData.length; i++) {
                    // Check related row data is empty or quantity is valid
                    if ((fileData[i][0] !== undefined && fileData[i][0] !== null && String(fileData[i][0]).trim() !== '') && (fileData[i][1] !== undefined && fileData[i][1] !== null && String(fileData[i][1]).trim() !== '' && !isNaN(+String(fileData[i][1])) && parseInt(String(fileData[i][1])) > 0)) {
                        const tmp = {
                            WorkOrderId: fileData[i][0]?.toString(),
                            CargoCompanyId: fileData[i][1]?.toString(),
                            CargoNo: fileData[i][2]?.toString(),
                            DispatchDate: fileData[i][3]?.toString(),
                            ReturnCargoNo: fileData[i][4]?.toString(),
                            OutCargoCompanyId: fileData[i][5]?.toString(),
                            OutDispatchDate: fileData[i][6]?.toString()
                        };

                        excelData.push(tmp);
                    }
                }

                if (excelData.length > 0) {
                    // Validate CargoCompanyId and OutCargoCompanyId are integers
                    for (let i = 0; i < excelData.length; i++) {
                        const item = excelData[i];
                        if (!Number.isInteger(Number(item.CargoCompanyId))) {
                            setResponseDsc('Invalid CargoCompanId at row ' + (i + 2));
                            setAlertType('error');
                            setOpenSnackbar(true);
                            return;
                        }
                        if (!Number.isInteger(Number(item.OutCargoCompanyId))) {
                            setResponseDsc('Invalid OutCargoCompanyId at row ' + (i + 2));
                            setAlertType('error');
                            setOpenSnackbar(true);
                            return;
                        }
                    }

                    dispatch(workOrderCargoThunks.UploadCargoReport(excelData)).then(response => {
                        if (response?.payload?.Code === '400') {
                            setResponseDsc(t('lblWorkOrderCargoSaveSuccess'));
                            setAlertType('success');
                            setOpenSnackbar(true);
                        } else {
                            setResponseDsc(response?.payload?.Message);
                            setAlertType('error');
                            setOpenSnackbar(true);
                        }
                    });
                }
            };
            // reader.onloadend = () => {
            //     // Clear the reader to allow trying another file
            //     e.target.value = null;
            // };
        }
    };

    return (
        <>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={()=> setOpenSnackbar(false)}
            >
                <Alert
                    onClose={()=> setOpenSnackbar(false)} message={ResponseDsc} variant={AlertType}
                />
            </Snackbar>
            <Grid container spacing={1}>
                <Grid item xs={2} sm={2} lg={2}>
                    <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider
                            utils={DateFnsUtils}
                            locale={localeMap[locale]}
                        >
                            <KeyboardDatePicker
                                color="primary"
                                inputVariant="outlined"
                                id="orderDate"
                                size="small"
                                invalidDateMessage={t('hatali_tarih')}
                                format="dd.MM.yyyy"
                                fullWidth
                                label={t('lblDispatchDate')}
                                variant="outlined"
                                value={selectedDispatchDate}
                                onChange={e => setDelectedDispatchDate(e)}
                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={1} sm={1} lg={1}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        endIcon={<SearchIcon />}
                        onClick={GetWorkOrderCargoReport}
                    >
                        {t('search')}
                    </Button>
                </Grid>
                <Grid item xs={1} sm={1} lg={1}>
                    <ExcelExport JsonData={cargoReportData} ButtonType={2} />
                </Grid>
                <Grid item xs={1} sm={1} lg={1}>
                    <input
                        id="FileInput"
                        type='file'
                        onChange={importExcel}
                        hidden
                        accept=".xlsx, .xls, .xml"
                    >
                    </input>
                    <label htmlFor="FileInput">
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            fullWidth
                            component="span"
                            endIcon={<ImportExportIcon />}
                        >
                            {t('lblUpload')}
                        </Button>
                    </label>
                </Grid>
                <Grid item xs={7} sm={7} lg={7}></Grid>
                <Grid
                    container
                    item
                    justify="space-between"
                    alignItems="center"
                    spacing={4}
                    xs={12}
                    sm={6}
                >
                    <Grid item xs={6} sm={6}>
                        <SearchBar
                            placeholder={t('lblSearch')}
                            value={cargoReportSearched}
                            onChange={(searchVal) => requestSearch(searchVal)}
                            onCancelSearch={() => cancelSearch()}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <TableContainer className={classes.container}>
                <Table
                    stickyHeader
                    aria-label="sticky table"
                    className={classes.table}
                    size="small"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">{t('lblId')}</TableCell>
                            <TableCell align="left">{t('lblWorkOrderId')}</TableCell>
                            <TableCell align="left">{t('lblCargoCompanyId')}</TableCell>
                            <TableCell align="left">{t('lblCargoCompanyName')}</TableCell>
                            <TableCell align="left">{t('lblCargoNo')}</TableCell>
                            <TableCell align="left">{t('lblCreateDate')}</TableCell>
                            <TableCell align="left">{t('lblUpdateDate')}</TableCell>
                            <TableCell align="left">{t('lblDispatchDate')}</TableCell>
                            <TableCell align="left">{t('lblReturnCargoNo')}</TableCell> {/* Added ReturnCargoNo header */}
                            <TableCell align="left">{t('lblOutCargoCompanyId')}</TableCell>
                            <TableCell align="left">{t('lblOutCargoCompanyName')}</TableCell>
                            <TableCell align="left">{t('lblOutDispatchDate')}</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(cargoReportData) ? cargoReportData.map((row, index) => (
                            <TableRow
                                // key={row.Id}
                                hover
                                classes={{ hover: classes.hover }}
                                className={classes.tableRow}
                            // onClick={() => handleRoute(row.Id)}
                            // onMouseEnter={() => handleMouseEnter(index)}
                            // onMouseLeave={handleMouseLeave}
                            // style={{ cursor: hoveredRowIndex === index ? 'pointer' : 'default' }}
                            >
                                <TableCell align="left">
                                    {row.Id}
                                </TableCell>
                                <TableCell align="left">
                                    {row.WorkOrderId}
                                </TableCell>
                                <TableCell align="left">
                                    {row.CargoCompanyId}
                                </TableCell>
                                <TableCell align="left">
                                    {row.CargoCompanyName}
                                </TableCell>
                                <TableCell align="left">
                                    {row.CargoNo}
                                </TableCell>
                                <TableCell align="left">
                                    {moment(row.CreateDate).format('DD-MM-YYYY')}
                                </TableCell>
                                <TableCell align="left">
                                    {moment(row.UpdateDate).format('DD-MM-YYYY')}
                                </TableCell>
                                <TableCell align="left">
                                    {moment(row.DispatchDate).format('DD-MM-YYYY')}
                                </TableCell>
                                <TableCell align="left">
                                    {row.ReturnCargoNo} {/* Added ReturnCargoNo cell */}
                                </TableCell>
                                <TableCell align="left">
                                    {row.OutCargoCompanyId}
                                </TableCell>
                                <TableCell align="left">
                                    {row.OutCargoCompanyName}
                                </TableCell>
                                <TableCell align="left">
                                    {row.OutDispatchDate ? moment(row.OutDispatchDate).format('DD-MM-YYYY') : null}
                                </TableCell>
                            </TableRow>
                        )) : null}
                    </TableBody>
                </Table>
            </TableContainer>
        </>


    )


}

export default CargoReport;